import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import PAtabs from "../PAtabs";
import PAh2 from "../PAh2";
import styled, { css } from "styled-components";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Pill,
  Button,
  Breadcrumbs,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification,
  ContentBlock
} from "xsolla-uikit";


import PAviGroup, { vi } from "../ingame/PAviGroup";
import { PAviItems } from "../ingame/PAviItems";
import PAgkRefund from "../ffr/PAgkRefund";

import {PAinfoCollapsible, CssClick, CssLineHover, CssSelectStatus, CssTh, CssThTd, CssThFilt0, CssCounter } from '../uikit2';


const tabs = {
  susbscribers: {
    title: 'Subscribers',
    component: ``,
    extra: <Pill appearance="active">+8</Pill>,
  },
  customers: {
    title: 'Customers',
    component: `<ContentBlock><PAh2 title="Customers" indentation="lg"/></<ContentBlock>`,
  }
}



const renderPage = ({
  title = 'Product',
  component = <div>Product</div>,
}) => {
  return (
    <ContentBlock><PAh2 title={title} indentation="lg"/>
      {component}
    </ContentBlock>
  )
}


const renderTabs = (tabs = {}) => {
  let tabsArr = Object.keys(tabs);
  if (tabsArr.length) return tabsArr.map((oneTabName, ind)=>{
    let oneTab = tabs[oneTabName];
    if (oneTab) return ({
      name: (
        <CssTab>
          {oneTab['title']}
          {!!oneTab['extra'] && <span><CssExtra>{oneTab['extra']}</CssExtra></span>}
          {!!oneTab['counter'] && <CssExtra><CssCounter>{oneTab['counter']}</CssCounter></CssExtra>}
        </CssTab>
      ),
      stateName: oneTabName,
      icon: oneTab['icon'],
    })
  })
}



const pageSetupExample = {
  root: 'support',
  title: 'Users',
  tabs: {
    subscribers: {
      title: 'Subscribers',
      pill: <Pill appearance="active">+8</Pill>,
      component: <PAgkRefund type="ingame" />,
      icon: "profile",
    },
    users2: {
      title: 'In-game store customers',
      component: <PAviGroup showAsPage={false} />,
      counter: 34,
    },
    users3: {
      title: 'Game store customers',
      icon: "profile"
    },
  },
}



const CssTab = styled.span`
  display: flex;
  align-items: center;
`
const CssExtra = styled.span`
  margin-left: 0.6em;
`







export default function PAcustomers({
  hist,
  root = pageSetupExample['root'],
  tabs = pageSetupExample['tabs'],
  title = pageSetupExample['title'],
}) {

  root = root ? `/${root}` : '';


  const [active, setActive] = useState();


  const renderComponents = (tabs = {}, active) => {
    let tabsArr = Object.keys(tabs);
    if (tabsArr.length) return tabsArr.map((oneTabName, ind)=>{
      let oneTab = tabs[oneTabName];
      if (oneTab && oneTabName === active) return (<ContentBlock>
        <PAh2 title={oneTab['title']}></PAh2>
        <FormGroup>
          {oneTab['component']}
        </FormGroup>
      </ContentBlock>
      )
    })
  }



  useEffect(() => {
    console.log("hist = ", hist);
    let newAction = hist.match.params.keyId || "users";
    console.log("newAction = ", newAction);

    if (!active) {
      setActive(newAction);
    }

    if (newAction && newAction !== active) {
      hist.history.push(`${root}/${newAction}`);
      setActive(newAction);
    }

    if (
      active &&
      newAction &&
      hist.location.pathname !== `${root}/${newAction}`
    ) {
      // debugger;
      hist.history.push(`${root}/${newAction}`);
      setActive(newAction);
    }

    return () => {};
  }, [hist]);





  return (

      <div className="xsui-width">


        <FormGroup indentation="md">
          <div style={{ display: "flex" }}>
            <Breadcrumbs
              items={[
                {
                  label: title,
                  to: root,
                }
              ]}
            />
            <PAtabs
              appearance="secondary"
              active={active}
              handleTab={nw => {
                hist.history.push(`${root}/${nw}`);
              }}
              items={renderTabs(tabs)}
            />
          </div>
        </FormGroup>



        {Object.keys(tabs).map((oneTabName, ind)=>{
          let oneTab = tabs[oneTabName];
          if (oneTab && oneTabName === active) return (<ContentBlock>
            <PAh2 title={oneTab['title']}></PAh2>
            <FormGroup>
              {oneTab['component']}
            </FormGroup>
          </ContentBlock>
          )
        })}







          {/* {action === "subscribers" && (
            <ContentBlock>
              <FormGroup border="xlg" style={{ width: "100%" }}>

              </FormGroup>
            </ContentBlock>
          )} */}






      </div>

  )
}
